/**
 * Create by zhuzhaoqing
 * Description: login
 * Date: 2023/3/31 10:12
 **/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'
const serveName = process.env.VUE_APP_SERVENAME

// 查询日志模块
export const queryTypeModule = () => request(`/${serveName}/operationLog/type/module`, null, 'GET', null)

// 查询操作类型
export const queryOpsModule = () => request(`/${serveName}/operationLog/type/ops`, null, 'GET', null)

// 查询日志列表
export const queryLogList = (data: {
  logType?: string
  tag?: string
  operatorName?: string
  pageNum: number
  pageSize: number
}) => request(`/${serveName}/operationLog/query`, null, 'POST_JSON', data)

// 查询日志详情
export const queryLogDetail = (data: { id: string }) => request(`/${serveName}/operationLog/get`, data, 'GET')
